// src/billing/CreateChangeOrder.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function CreateChangeOrder() {
  const navigate = useNavigate();

  const [projectSearch, setProjectSearch] = useState('');
  const [selectedProject, setSelectedProject] = useState(null);
  const [lineItems, setLineItems] = useState([{ description: 'Additional wiring', quantity: 1, unitPrice: 0 }]);
  const [reason, setReason] = useState('');

  const dummyProjects = [
    { id: 1, poNumber: '0001', title: 'DMV Panel Upgrade' },
    { id: 2, poNumber: '0002', title: 'Residential Rewire' },
  ];

  const filteredProjects = dummyProjects.filter(p => p.poNumber.includes(projectSearch) || p.title.toLowerCase().includes(projectSearch.toLowerCase()));

  const addLineItem = () => setLineItems([...lineItems, { description: '', quantity: 1, unitPrice: 0 }]);

  const updateItem = (index, field, value) => {
    const updated = [...lineItems];
    updated[index][field] = value;
    setLineItems(updated);
  };

  const removeItem = (index) => {
    // Last remaining row: X clears it instead of removing (there's always one row).
    if (lineItems.length > 1) setLineItems(lineItems.filter((_, i) => i !== index));
    else setLineItems([{ description: '', quantity: 1, unitPrice: 0 }]);
  };

  const additionalCost = lineItems.reduce((sum, i) => sum + (Number(i.quantity) * Number(i.unitPrice)), 0);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f6f9fc', padding: '32px 40px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: '#32325d' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
        <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 600 }}>Create Change Order</h1>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button style={{ padding: '10px 20px', border: '1px solid #e6e6e6', borderRadius: '6px', background: 'white', cursor: 'pointer' }} onClick={() => navigate('/billing')}>Cancel</button>
          <button style={{ padding: '10px 20px', background: '#635bff', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 600, cursor: 'pointer' }}>Save Change Order</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '32px' }}>
        {/* Left - Form */}
        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', padding: '32px' }}>
          {/* Project/PO Search */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: 600, margin: '0 0 12px' }}>Linked Project / PO</h2>
            <input type="text" placeholder="Search by PO number or title…" value={projectSearch} onChange={e => setProjectSearch(e.target.value)} style={{ width: '100%', padding: '12px 16px', border: '1px solid #ccd0d5', borderRadius: '6px', fontSize: '16px' }} />
            {projectSearch && (
              <div style={{ marginTop: '8px', border: '1px solid #ccd0d5', borderRadius: '6px', maxHeight: '200px', overflowY: 'auto', background: 'white' }}>
                {filteredProjects.map(p => (
                  <div key={p.id} onClick={() => { setSelectedProject(p); setProjectSearch(''); }} style={{ padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}>
                    <strong>{p.poNumber}</strong> — {p.title}
                  </div>
                ))}
              </div>
            )}
          </section>

          {/* Reason */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: 600, margin: '0 0 12px' }}>Reason for Change</h2>
            <textarea value={reason} onChange={e => setReason(e.target.value)} placeholder="Describe the change (e.g., additional circuit requested by client)" style={{ width: '100%', height: '120px', padding: '12px 16px', border: '1px solid #ccd0d5', borderRadius: '6px' }} />
          </section>

          {/* Change Items */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 600, margin: '0 0 16px' }}>Additional Items / Cost</h2>
            {lineItems.map((item, index) => (
              <div key={index} style={{ display: 'grid', gridTemplateColumns: '3fr 100px 140px 40px', gap: '12px', marginBottom: '12px', alignItems: 'center' }}>
                <input placeholder="Description of change" value={item.description} onChange={e => updateItem(index, 'description', e.target.value)} style={{ padding: '12px 16px', border: '1px solid #ccd0d5', borderRadius: '6px' }} />
                <input type="number" min="1" value={item.quantity} onChange={e => updateItem(index, 'quantity', e.target.value)} style={{ padding: '12px 16px', border: '1px solid #ccd0d5', borderRadius: '6px', textAlign: 'right' }} />
                <input type="number" step="0.01" value={item.unitPrice} onChange={e => updateItem(index, 'unitPrice', e.target.value)} placeholder="0.00" style={{ padding: '12px 16px', border: '1px solid #ccd0d5', borderRadius: '6px', textAlign: 'right' }} />
                <button onClick={() => removeItem(index)} style={{ background: 'none', border: 'none', color: '#9b9fa7', fontSize: '20px', cursor: 'pointer' }}>×</button>
              </div>
            ))}
            <button onClick={addLineItem} style={{ color: '#635bff', background: 'none', border: 'none', fontSize: '15px', cursor: 'pointer' }}>+ Add change item</button>
          </section>
        </div>

        {/* Right - Preview */}
        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', padding: '20px', height: 'fit-content', position: 'sticky', top: '100px' }}>
          <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', aspectRatio: '8.5 / 11', background: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
            <div style={{ padding: '40px 48px', height: '100%', display: 'flex', flexDirection: 'column', fontSize: '14px', color: '#000' }}>
              <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                <h3 style={{ margin: 0, fontSize: '24px', fontWeight: 600 }}>CHANGE ORDER</h3>
                <p style={{ margin: '8px 0 0', color: '#666' }}>Linked to PO {selectedProject?.poNumber || 'N/A'}</p>
              </div>

              <div style={{ marginBottom: '32px' }}>
                <strong>Project:</strong> {selectedProject?.title || 'Select project'}<br />
                <strong>Reason:</strong> {reason || 'N/A'}
              </div>

              <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '24px' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #000' }}>
                    <th style={{ textAlign: 'left', paddingBottom: '8px' }}>Description</th>
                    <th style={{ textAlign: 'right', paddingBottom: '8px' }}>Qty</th>
                    <th style={{ textAlign: 'right', paddingBottom: '8px' }}>Unit Price</th>
                    <th style={{ textAlign: 'right', paddingBottom: '8px' }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {lineItems.filter(i => i.description.trim()).map((item, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '12px 0' }}>{item.description}</td>
                      <td style={{ textAlign: 'right', padding: '12px 0' }}>{item.quantity}</td>
                      <td style={{ textAlign: 'right', padding: '12px 0' }}>${Number(item.unitPrice).toFixed(2)}</td>
                      <td style={{ textAlign: 'right', padding: '12px 0', fontWeight: 600 }}>${(Number(item.quantity) * Number(item.unitPrice)).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ marginLeft: 'auto', width: '40%', textAlign: 'right' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span>Additional Cost</span>
                  <span>${additionalCost.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateChangeOrder;